import { render, staticRenderFns } from "./SkuTrendMock.vue?vue&type=template&id=b5940e74&"
import script from "./SkuTrendMock.vue?vue&type=script&lang=js&"
export * from "./SkuTrendMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports